export const mensajeStyles = 
{
  'avatar': {
    width: '32px',
    height: '32px',
  },
  'box':{
    paddingBottom:'0px',
    float: 'right' as 'right',
    width: '80%',
    paddingTop:'9px',
  },
  'box_finalizar':{
    float: 'right' as 'right',
  },
  'box_alert':{
    float: 'right' as 'right',
  }

}